import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 登录
 */
const login = {

  /**
   * 登录
   * @param {*} account 账号
   * @param {*} password 密码
   * @returns 
   */
  login (account, password) {
    return axios.post(base.login.login, utils.postParamsArrayToJsonString({ account, password }))
  },
  /**
   * 登出
   */
  logout () {
    return axios.post(base.login.logout)
  },
  /**
   * 绑定当前会话的公司
   * @param {*} companyId 公司id
   * @returns 
   */
  bindCompanyOfCurrentSession (companyId) {
    return axios.post(base.login.bindCompanyOfCurrentSession, utils.postParamsArrayToJsonString({ companyId }))
  },
}

export default login